module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"cornerstone-core","commonjs2":"cornerstone-core","amd":"cornerstone-core","root":"cornerstone"}
// module id = 1
// module chunks = 0